import React, { useEffect, useState } from 'react';
import InfoIcon from '@mui/icons-material/Info';
import HistoryIcon from '@mui/icons-material/History';
import { Link, useNavigate, useParams } from 'react-router-dom';
import S from './ListDam.module.css'
import D from '../images/history.svg'

import {  useSelector } from 'react-redux';


import apiService from '../api/ApiService';
import DatePicker from '@hassanmojab/react-modern-calendar-datepicker';
import { DateRangeRounded, KeyboardBackspace } from '@mui/icons-material';
import { Pagination } from '@mui/material';
import useHistory from '../Components/CustomHooks/useHistory';
import EmptyReturn from '../Components/EmptyReturn';
const moment=require('moment-jalaali')
const imp=['🔴','🟡','🔵','🟣','🟢']
export default function ListSensorHistory() {
  const navigate=useNavigate()
  const flag='sensorStatus';
  const {total,page,handlePage,data,SData,setSdata,selectedDayRange, setSelectedDayRange,renderCustomInput,importanceLevel,setImportancelevel,importanceList}=useHistory(flag)
  
  return (
    <div className={S.AllAnimalssLICon}>
      <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',width:'100%'}}>
      <div className={S.AllAnimalssTitleLICon}>
        <img className={S.AllAnimalssIconimgLITit} style={{width:'70px',height:'70px'}} src={D}/>
        <h2> تاریخچه وضعیت سنسور</h2>
        </div>
        <div onClick={()=>{navigate(-1)}}  className='backButton' >
          <KeyboardBackspace fontSize='large'/>
        </div>
       
           
      </div>
        <hr/>
        <div className='d-flex justify-content-between ' style={{direction:'ltr'}}>
        <div class="inputContainerSS">
                           <DatePicker
                           value={selectedDayRange}
                           onChange={setSelectedDayRange}
                             locale='fa'
                             calendarClassName="birthCalender"
                             renderInput={renderCustomInput}
                             />
                             
                           
                              
                       </div>
                       <select value={importanceLevel} onChange={(e)=>{setImportancelevel(e.target.value)}} style={{direction:'rtl',alignSelf:'end'}}   id='sele'  name='sele' className={`selectInp ${S.selectStyle}`}  >
    <option  value={'null'} >فیلتر بر اساس اهمیت</option>
    {importanceList?.length&&importanceList.map((item,index)=>{
      return <option key={index} value={item.id} >{item?.description}</option>
    })}        
                            
                       
                    </select>
                            
 
        </div>
        <div className={S.TabForAllAnnimLICon} >
          
          
          <div className={S.AnimContentLI} style={{borderTopLeftRadius:'0px'}} data-aos='fade'>
          {data.length?<table>
              <thead>
                <tr>
                <th>
                    ردیف
                  </th>
                  <th>
                    مقدار قدیم
                  </th>
                  <th>
                     مقدار حال حاضر
                  </th>
                  <th>
                    سطح اهمیت
                  </th>
                  <th>
                     تاریخ
                  </th>
                  <th>
                    شناسه سنسور
                  </th>
                </tr>
              </thead>
              <tbody>
                {
                  data?.length&&data?.map((item,index)=>{
                    const {entryDate}=item;
                    const birth=entryDate?.substring(0,10);
                    const pbirth=moment(birth).format('jYYYY-jMM-jDD')
                    return <tr key={index}>
                    <td>
                      {index+1}
                    </td>
                    <td>
                      {item?.oldSensorStatusTitle}
                    </td>
                    <td>
                      {item?.newSensorStatusTitle}
                    </td>
                    <td>
                      {imp[item?.newSensorStatusImportanceLevel]} {item?.newSensorStatusImportanceLevelTitle}
                    </td>
                    <td>
                      {pbirth}
  
                    </td>
                    
                    <td className={S.DetIc}>
                      {item?.sensorId}
                    </td>
                    
                  </tr>
                  
                  })
                }
                
                
                
                
                

              </tbody>
            </table>:<EmptyReturn/>}
          </div>
        </div>
        <div className='PaginateContainer'>
            <Pagination defaultPage={1} count={total} page={page==0?page+1:page} onChange={handlePage} variant="outlined" color="primary"  boundaryCount={2}/>
            </div>
    </div>
  );
}